export const PIXEL_ID = '1177396971612928';

export function trackInitiateCheckout() {
  window.fbq?.('track', 'InitiateCheckout');
}
